import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selected", "service", "button"]

  connect() {
    // Initialize the dropdown when the controller connects
    this.updateSelectedDisplay();
  }

  selectService(event) {
    // Prevent default link behavior
    event.preventDefault();

    // Get the selected service element
    const selectedService = event.currentTarget;

    // Update the selected service
    this.selectedTarget.innerHTML = selectedService.innerHTML;

    // Update the button href to the selected service's data-href value
    const serviceUrl = selectedService.dataset.href;
    this.buttonTarget.href = serviceUrl;

    // Remove 'active' class from all services
    this.serviceTargets.forEach(service => service.classList.remove('active'));

    // Add 'active' class to the selected service
    selectedService.classList.add('active');

    // Close the dropdown after selection
    this.element.querySelector('[data-action="dropdown#toggle:stop"]').click();
  }

  updateSelectedDisplay() {
    // Find the initially selected service (with 'active' class)
    const activeService = this.serviceTargets.find(service => service.classList.contains('active'));

    if (activeService) {
      this.selectedTarget.innerHTML = activeService.innerHTML;
      // Also set the initial button href
      this.buttonTarget.href = activeService.dataset.href;
    } else if (this.serviceTargets.length > 0) {
      // If no active service, select the first one
      this.serviceTargets[0].classList.add('active');
      this.selectedTarget.innerHTML = this.serviceTargets[0].innerHTML;
      // Set the button href to the first service
      this.buttonTarget.href = this.serviceTargets[0].dataset.href;
    }
  }
}
